export default __webpack_public_path__ + "static/media/_IMG1199.4ad01678.jpg";